import cx from "classnames";
import GptAd, { GptAdProps } from "./GptAd";
import styles from "./DesktopInjector.module.scss";

const DesktopInjectorAd = ({ className, ...props }: GptAdProps) => {
  const sizes = props.targetingNative ? "desktop-wide,native" : "desktop-wide";

  return (
    <GptAd
      className={cx(styles.root, className)}
      format="injector"
      sizesAt0=""
      sizesAt976={sizes}
      {...props}
    />
  );
};

export default DesktopInjectorAd;
